/* External dependencies */
import { concat, from, of } from 'rxjs';
import { catchError, filter, switchMap } from 'rxjs/operators';

/* Local dependencies */
import { getClient } from '../../../../../clients/client';
import { Warehouse } from '../../types';
import { listWarehouses } from '../../list-warehouses/redux/action';
import { updateWarehouseError, updateWarehouseSuccess } from './action';
import { updateWarehouseMutation } from './mutation';
import { UpdateWarehouseActionTypes, UpdateWarehouseInput, UpdateWarehouseRequest } from './types';

export default function updateWarehouseEpic(action$, state$) {
  return action$.pipe(
    filter((action: UpdateWarehouseRequest) => action.type === UpdateWarehouseActionTypes.UPDATE_WAREHOUSE),
    switchMap((action: UpdateWarehouseRequest) =>
      from(updateWarehouse(action.input)).pipe(
        switchMap((warehouse) => {
          const currentState = state$.value;
          const { statuses } = currentState.listWarehouses;

          return concat(from([updateWarehouseSuccess(warehouse)]), from([listWarehouses({ filter: { statuses } })]));
        }),
        catchError((error) => of(updateWarehouseError(error))),
      ),
    ),
  );
}

export async function updateWarehouse(input: UpdateWarehouseInput): Promise<Warehouse> {
  const graphQLClient = await getClient();

  const {
    data: { updateWarehouse },
  } = await graphQLClient.mutate({
    mutation: updateWarehouseMutation,
    variables: { input },
  });

  return updateWarehouse;
}
